// Define the layer configuration interface
export interface LayerConfig {
  id: string;
  name: string;
  visible: boolean;
  kmlUrl: string; // KML URL is now mandatory
  style?: any; // Optional style for non-KML layers in the future
}

// Couloirs layer configuration
export const couloirsLayer: LayerConfig = {
  id: 'couloirs',
  name: 'Couloirs',
  visible: true,
  kmlUrl: `/data/couloirs.geojson`,
  style: { color: '#333333', fillColor: '#888888', fillOpacity: 0.3, weight: 0.7 }
};
export const mejharsLayer: LayerConfig = {
  id: 'mejhars',
  name: 'Mejhars',
  visible: true,
  kmlUrl: `/data/Mejhars-fixed.geojson`,
  style: { color: '#c2185b', fillColor: '#c2185b', fillOpacity: 0.6, weight: 2 }
};
export const petiteMineLayer: LayerConfig = {
  id: 'petite-mine',
  name: 'Permis petite mine',
  visible: true,
  kmlUrl: `/data/ultime-ppem-enVigeur-fixed.geojson`,
  style: { color: '#000000', fillColor: '#ffd700', fillOpacity: 0.2, weight: 0.1 } // black hair-thin outline, subtle gold fill
};
export const zonesCommercialesLayer: LayerConfig = {
  id: 'zones-commerciales',
  name: 'Zones commerciales',
  visible: true,
  kmlUrl: `${process.env.PUBLIC_URL}/data/ZonesCommerciales.kml`,
  style: { color: '#8e24aa' } // purple
};
export const zonesCategorieFLayer: LayerConfig = {
  id: 'zones-categorie-f',
  name: 'Zones catégorie F',
  visible: true,
  kmlUrl: `${process.env.PUBLIC_URL}/data/ZonesCategorieF.kml`,
  style: { color: '#009688' } // teal
};
export const permisIndustrielsLayer: LayerConfig = {
  id: 'permis-industriels',
  name: 'Permis industriels',
  visible: true,
  kmlUrl: `${process.env.PUBLIC_URL}/data/PermisIndustriels.kml`,
  style: { color: '#8d6e63' } // brown
};
export const foragesLayer: LayerConfig = {
  id: 'forages',
  name: 'Forages',
  visible: true,
  kmlUrl: `/data/forages.geojson`,
  style: { color: '#87CEEB' } // light blue
};
export const centresTraitementLayer: LayerConfig = {
  id: 'centres-traitement',
  name: 'Centres de traitement',
  visible: true,
  kmlUrl: `${process.env.PUBLIC_URL}/data/CentresTraitement.kml`,
  style: { color: '#e91e63' } // pink
};
export const routesLayer: LayerConfig = {
  id: 'routes',
  name: 'Routes',
  visible: true,
  kmlUrl: `${process.env.PUBLIC_URL}/data/Routes.kml`,
  style: { color: '#757575' } // gray
};
export const bureauxMaadenLayer: LayerConfig = {
  id: 'bureaux-maaden',
  name: 'Bureaux MAADEN',
  visible: true,
  kmlUrl: `${process.env.PUBLIC_URL}/data/BureauxMaaden.kml`,
  style: { color: '#ffe082' } // yellow
};

export const zonesCommercialesGroup: LayerConfig = {
  id: 'zones-commerciales',
  name: 'Zones commerciales',
  visible: true,
  kmlUrl: '', // This is a group, no direct URL
  style: { color: '#8e24aa', fillColor: '#8e24aa', fillOpacity: 0.3, weight: 1 } // purple
};



// Export all permanent layers
export const permanentLayers: LayerConfig[] = [
  couloirsLayer,
  mejharsLayer,
  petiteMineLayer, // Now uses ultime-ppem-enVigeur-fixed.geojson
  zonesCommercialesGroup,
  foragesLayer, // Add forages layer
  // Note: Other layers (zones commerciales, forages, etc.) are commented out because their KML files don't exist
  // zonesCommercialesLayer,
  // zonesCategorieFLayer,
  // permisIndustrielsLayer,
  // foragesLayer,
  // centresTraitementLayer,
  // routesLayer,
  // bureauxMaadenLayer,
];
